module.exports = __webpack_public_path__ + "img/5_uk.4642b710.svg";